import s from './styles.scss';

const Item = ({ image, title, desc }) => (
  <div className={s.item}>
    <div className={s.imgWrapper}>
      <img src={image} />
    </div>

    <h3>{title}</h3>
    <span>{desc}</span>
  </div>
);

export default Item;
